import React from "react";
import { Container, Box, Paper } from "@mui/material";
import Main from "./Main";
const VendorRegistration = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 8, px: 1 }} disableGutters>
      <Box display={"flex"} justifyContent="center" padding={1}>
        <Paper elevation={6} sx={{ width: "80%", borderRadius: "10px" }}>
          <div>
            <Box sx={{ width: "100%" }}>
              <Main />
            </Box>
          </div>
        </Paper>
      </Box>
    </Container>
  );
};

export default VendorRegistration;
